import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";
import { numberFormatter } from "@common/helpers/number";
import { pluralize } from "@common/helpers/string";
import { useBulkActions } from "../useBulkActions";

interface BulkDeleteConfirmationModalProps {
    show: boolean;
    onHide: () => void;
    onConfirm: () => Promise<void>;
}

export const BulkDeleteConfirmationModal: React.FC<
    BulkDeleteConfirmationModalProps
> = ({ show, onHide, onConfirm }) => {
    const bulkActions = useBulkActions();
    const count = bulkActions.selectedCount;
    const transactionWord = pluralize("transaction", count);

    return (
        <ConfirmationModal
            show={show}
            onHide={onHide}
            onReject={onHide}
            onConfirm={onConfirm}
            title={`Delete ${numberFormatter.format(count)} ${transactionWord}`}
            question={`Are you sure you want to delete ${numberFormatter.format(count)} ${transactionWord}? This action can be undone.`}
            yes="Delete"
            yesBtnVariant="destructive"
        />
    );
};
